import { REQUESTED_MQL_PLUS_COPY, RECEIVED_MQL_PLUS_COPY, REQUEST_MQL_PLUS_COPY_FAILED } from '../actions/GetMqlPlusCopy';

const initialState = {
  loading: true,
  data: {},
};

const mqlPlusCopy = (state = initialState, action) => {
  switch (action.type) {
    case REQUESTED_MQL_PLUS_COPY:
      return initialState;
    case RECEIVED_MQL_PLUS_COPY:
      return {
        data: action.data,
        loading: false,
      };
    case REQUEST_MQL_PLUS_COPY_FAILED:
      return Object.assign({}, initialState, {
        loading: false,
      });
    default:
      return state;
  }
};

export default mqlPlusCopy;
